module.exports = __webpack_public_path__ + "img/icon_5.2deb64f1.png";